import "./Plans.scss"
import React from "react"
import { observer } from "mobx-react"
import { billingStore } from "../../app/stores"
import { Button } from "../../lib"
import {
  FREE_PLAN,
  GROWTH_PLAN_MONTHLY,
  GROWTH_PLAN_ANNUALLY,
  BUSINESS_PLAN_MONTHLY,
  BUSINESS_PLAN_ANNUALLY,
} from "./subscription-plans"
import Plan from "./Plan"

const Plans = ({ value, onChange }) => {
  const { showAnnual, setAnnual } = billingStore
  return (
    <div>
      <header className="Plans_header">
        <p className="Plans_prompt">
          Change your plan at any time. Simply select the tier that's right for
          you.
        </p>
        <Button
          styleType="tab"
          active={showAnnual}
          onClick={() => setAnnual(true)}>
          Annually
        </Button>
        <Button
          styleType="tab"
          active={!showAnnual}
          onClick={() => setAnnual(false)}>
          Monthly
        </Button>
      </header>
      <ul className="Plans">
        <li>
          <Plan plan={FREE_PLAN} />
        </li>
        <li>
          <Plan
            plan={showAnnual ? GROWTH_PLAN_ANNUALLY : GROWTH_PLAN_MONTHLY}
          />
        </li>
        <li>
          <Plan
            plan={showAnnual ? BUSINESS_PLAN_ANNUALLY : BUSINESS_PLAN_MONTHLY}
          />
        </li>
      </ul>
    </div>
  )
}

Plans.displayName = "Plans"

export default observer(Plans)



// WEBPACK FOOTER //
// ./src/account/billing/Plans.js